<div class="bubble bubble-{{ index }}" [style.transform]="transformStyle"></div>
